module.exports = __webpack_public_path__ + "static/media/cyber-safety.5996da2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/cyber-safety.jpg
// module id = 826
// module chunks = 0